import React from 'react';
import PropTypes from 'prop-types';
import { LockOutlined, SyncOutlined, UserOutlined, LoadingOutlined } from '@ant-design/icons';
import { Input, Button, Checkbox, Row, Col, Form } from 'antd';
import { Link, withRouter } from 'react-router-dom';
import { connect } from "react-redux";

class NewPasswordRequiredForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      error: props.error,
      password: '',
    };
  }

  onSubmit = () => {
    // console.log(this.state.password);
    // event.preventDefault();
    this.props.onSubmit(this.state.password);
  }

  changePassword = (event) => {
    this.setState({ password: event.target.value });
  }

  render = () => {
    const formDiv = {
      'display': 'flex',
      'justifyContent': 'space-around',
      'margin-top': '40px',
    }

    const formStyle = {
      'background-color': 'white',
      'borderRadius': '5px'

    }

    const logoStyle = {
      'display': 'flex',
      'justifyContent': 'space-around',
      'marginBottom': '30px'
    }
    return <Row className='justify-on-mobile'>
        <Col span={12} className='hide-on-mobile'>
          <img className="branding-image" src={'/img/introImage.png'} alt="Brand"/>
        </Col>
        <Col xs={22} sm={22} md={24} lg={12} className='web-desktop-width'>
          <div className="input-form custom-frm" style={formDiv}>
            <div style={formStyle}>
              <div style={formDiv}>
                <div style={formStyle}>
                
                <Form onFinish={this.onSubmit} onFinishFailed={(e) => console.log(e) } className="login-form">
                    <h3 className="manrope f-24 w-700 black-00">
                     Set new password
                    </h3>
                  <p className='manrope f-14 w-500 black-00'>You must set your password on first login</p>
                    <Form.Item name='password'
                      rules={[{ required: true, message:  <span className='manrope f-14 red'>Please enter your password</span> },
                      {pattern: "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$", message:  <span className='manrope f-14 red'>Password should be atleast 8 characters including at least one uppercase, one lower, one special character and a digit</span> }
                    ]}
                    >
                        
                        <Input
                          className='manrope f-14 w-400 placeholder black'
                          type="password"
                          placeholder="Password"
                          onChange={this.changePassword}
                        />
                    </Form.Item>
                    <div className="manrope f-14 red text-left">{this.props.error}</div>

                    <Form.Item >

                      <Button htmlType="submit" className="modal-okay square font-16 center-btn mt-16">
                        Set new password {this.state.isLoading ? <LoadingOutlined spin /> : ''}
                      </Button>
                    </Form.Item>
                    <div className="text-danger text-center">{this.props.error}</div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
          <Col md={24} lg={12} className='show-on-mobile mt-40 justify-in-center'>
          <img className="branding-image login-page-mobile-img" src={'/img/introImageMobile.png'} />
        </Col>
        </Col>
      </Row>
    
  }
}
NewPasswordRequiredForm.propTypes = {
  onSubmit: PropTypes.func,
  error: PropTypes.string,
};

export default NewPasswordRequiredForm;
